import { Divider, Stack } from '@mui/material';

import { Text, api, isDefined } from 'common';

import { FHIR_VARIANTS } from './FhirVariants';
import { FhirBlockDocumentationMarkdown } from './documentation';
import {
  BlockSelectField,
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';
import { type BlockConfigProps } from '../../types';

const FhirEndpoint = api.FlowDefinition.FhirEndpoint;
type FhirEndpoint = api.FlowDefinition.FhirEndpoint;

const FHIR_ENDPOINTS = Object.values(FhirEndpoint);

function FormFields() {
  const { value: endpoint } =
    useSelectedNodeField<api.FlowDefinition.FhirConfig['endpoint']>('config.endpoint');
  const { Config } = isDefined(endpoint) ? FHIR_VARIANTS[endpoint] : { Config: null };
  return (
    <>
      <BlockSelectField
        label="FHIR Service"
        fieldName="config.endpoint"
        required
        options={FHIR_ENDPOINTS.map((endpoint) => ({
          label: endpoint,
          value: endpoint,
        }))}
      />
      <Stack gap={3}>
        {endpoint && ![FhirEndpoint.PractitionerSearch].includes(endpoint) && (
          <Stack gap={2}>
            <Text variant="heading5" bold>
              Patient
            </Text>
            <ParentBlockSelectField
              fieldName="config.patient.sourceBlockName"
              label="Patient Source"
              required={
                endpoint &&
                ![FhirEndpoint.GetPatient, FhirEndpoint.PractitionerSearch].includes(endpoint)
              }
              helperText={getSourceBlockNameHelperText('patient')}
            />
          </Stack>
        )}
        {Config && (
          <>
            <Divider
              sx={{
                // Manually override bootstrap hr override.
                opacity: 1,
              }}
            />
            <Config />
          </>
        )}
      </Stack>
    </>
  );
}

export const fhirBlockConfig: BlockConfigProps<api.FlowDefinition.FhirBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'fhir',
  defaultConfig: {
    endpoint: api.FlowDefinition.FhirEndpoint.GetPatient,
    patientSearchFilters: {
      lastName: '',
      dateOfBirth: '',
      phoneNumber: '',
      firstName: '',
    },
    returnType: api.FlowDefinition.ProducedType.FhirPatientResponse,
  },
  configFields: {
    schema: api.FlowDefinition.FhirConfigSchema,
    FormFields,
  },
  documentationMarkdown: FhirBlockDocumentationMarkdown,
};
